import { render, staticRenderFns } from "./global-list.vue?vue&type=template&id=039feec4&scoped=true"
import script from "./global-list.vue?vue&type=script&lang=js"
export * from "./global-list.vue?vue&type=script&lang=js"
import style0 from "./global-list.vue?vue&type=style&index=0&id=039feec4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039feec4",
  null
  
)

export default component.exports